import { defineMessages, FormattedMessage } from 'react-intl';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { Typography } from '@/components/Typography';

const intlPrefix = 'newsletter';

export const NewsLetterDesc = (
  <FormattedMessage
    defaultMessage='New versions, new models, special events... Keep up to date with the latest Breitling news.'
    id='newsletter.desc'
    values={{
      br: <br />,
    }}
  />
);

export const NewsLetterSubSuccessDescUser = (
  <FormattedMessage
    defaultMessage='Thank you for submitting your subscription. Customize your Newsletter Preferences anytime through My Account.'
    id='newsletter.NewsLetterSubSuccessDescUser'
  />
);

export const NewsLetterUnSubSuccessDescUser = (
  <FormattedMessage
    defaultMessage='Your unsubscription has been submitted.'
    id='newsletter.newsLetterUnSubSuccessDescUser'
  />
);

export const NewsLetterSubSuccessDescGuest = (
  <FormattedMessage
    defaultMessage='We have sent an email to the address you entered during registration. Click on the link to confirm your email address. It may take a few minutes to receive a confirmation email. If you do not receive a confirmation email, be sure to check your spam folder.'
    id='newsletter.subscriptionConfirmationMessage'
    values={{
      strong: (...chunks) => (
        <Typography className='newsletter-subscribed-title' mb={3}>
          {chunks}
        </Typography>
      ),
      br: <br />,
      mailto: (...chunks) => (
        <LinkWithLocale
          className='newsletter-subscribed-mailto'
          href={`mailto: ${chunks}`}
          rel='noreferrer'
          target='_blank'
        >
          {chunks}
        </LinkWithLocale>
      ),
    }}
  />
);

export const NewsLetterSubConfirmDescLine1Guest = (
  <FormattedMessage
    defaultMessage='Your subscription has been submitted.'
    id='newsletter.newsLetterSubConfirmDescLine1Guest'
  />
);

export const NewsLetterSubConfirmDescLine2Guest = (
  <FormattedMessage
    defaultMessage='The Breitling universe is at your fingertips.'
    id='newsletter.newsLetterSubConfirmDescLine2Guest'
  />
);

export const NewsletterTitle = (
  <FormattedMessage
    defaultMessage='Newsletter'
    id='newsletter.newsletterTitle'
  />
);

export const NewsletterSubscribe = (
  <FormattedMessage
    defaultMessage='Subscribe'
    id='newsletter.newsLetterSubscribe'
  />
);

export const NewsletterSubscribeError = (
  <FormattedMessage
    defaultMessage='Subscribe Error'
    id='newsletter.newsLetterSubscribeError'
  />
);

export const NewsLetterViewExclusiveUpdates = (
  <FormattedMessage
    defaultMessage='From new features to our latest collections and unique releases, be the first to know about our exclusive updates.'
    id='newsletter.newsLetterViewExclusiveUpdates'
  />
);

export const NewsLetterViewStayUpToDate = (
  <FormattedMessage
    defaultMessage='Stay up-to-date on all the news from the world of Breitling by joining our squad.'
    id='newsletter.newsLetterViewStayUpToDate'
  />
);

export const defined = defineMessages({
  newsLetterButton: {
    defaultMessage: 'Submit',
    id: `${intlPrefix}.newsLetterButton`,
  },
});
